import { FC } from 'react';

import { Box, FormControlLabel, Paper, Radio, RadioGroup, Typography } from '@mui/material';

interface InputRadioProps {
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: {
    title: string;
    value: string;
  }[];
  disabled?: boolean;
}

export const InputRadio: FC<InputRadioProps> = ({ options, value, handleChange, disabled }) => {
  return (
    <RadioGroup
      sx={{
        '& > *:not(:last-child)': {
          mb: 1,
        },
      }}
      value={value}
      onChange={handleChange}
    >
      {options.map((option) => (
        <Paper
          key={option.value}
          sx={{
            alignItems: 'flex-start',
            display: 'flex',
            width: '100%',
          }}
          variant="outlined"
        >
          <FormControlLabel
            control={<Radio />}
            key={option.value}
            sx={{
              p: 1.5,
              pl: 1,
              width: '100%',
              m: 0,
              backgroundColor: 'background.default',
              borderRadius: 1,
              boxShadow: 7,
              overflowWrap: 'anywhere',
            }}
            label={
              <Box sx={{ ml: 2 }}>
                <Typography
                  sx={{
                    color: 'text.primary',
                  }}
                  variant="h6"
                >
                  {option.title}
                </Typography>
              </Box>
            }
            value={option.value}
            disabled={disabled}
          />
        </Paper>
      ))}
    </RadioGroup>
  );
};
